import type { WritableAtom } from 'jotai'
import { useSetAtom } from 'jotai'
import { useMemo } from 'react'

/**
 * This hook is responsible for setting an atom's value when the
 * given value changes.
 */
export function useSetAtomOnValueChange<T>(
  atom: WritableAtom<null, T[], void>,
  value: T
) {
  const set = useSetAtom(atom)
  useMemo(() => {
    set(value)
  }, [set, value])
}
